import { css } from '@emotion/react';
import { ReactNode } from 'react';
import ProgressBar from './ProgressBar';

interface LayoutProps {
  children: ReactNode;
  title: string;
  description?: string;
  progress?: number;
}

function Layout({ children, title, description, progress }: LayoutProps) {
  return (
    <div css={Container}>
      <div css={ProgressBarContainer}>{progress && <ProgressBar progress={progress} />}</div>
      <div style={{ marginTop: '40px' }}>
        <h1 css={Title}>{title}</h1>
      </div>
      <p css={Description}>{description}</p>
      <div css={Content}>{children}</div>
    </div>
  );
}

export default Layout;

const Container = css`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
`;

const ProgressBarContainer = css`
  width: 100vw;
  height: 4px;
  background-color: #e9ebf1;
  border-radius: 2px;
  overflow: hidden;
  position: sticky;
  top: 58px;
  z-index: 100;
`;

const Title = css`
  color: #000;
  text-align: center;
  font-feature-settings: 'liga' off, 'clig' off;

  /* Desktop/display-L */
  font-family: Pretendard;
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px; /* 114.286% */
`;

const Description = css`
  font-size: 16px;
  font-weight: 400;
  margin-top: 8px;
  color: var(--Semantic-text-Subdued, #797d88);
  font-feature-settings: 'liga' off, 'clig' off;

  /* Body */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`;

const Content = css`
  width: 100%;
  height: 100%;

  margin-top: 24px;
`;
